/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
import regeneratorRuntime from "regenerator-runtime";
export var KEY_ICSTORAGE_KEY = "identity";
export var KEY_ICSTORAGE_DELEGATION = "delegation";
export var KEY_ICSTORAGE_WALLET = "wallet";
export var KEY_DELEGATION_PARAMS = "delegation_params";
export var IDENTITY_PROVIDER_DEFAULT = "https://identity.ic0.app";
export var IDENTITY_PROVIDER_ENDPOINT = "#authorize";
export function _deleteStorage(storage) {
    return __deleteStorage.apply(this, arguments);
}
function __deleteStorage() {
    __deleteStorage = _asyncToGenerator(regeneratorRuntime.mark(function _callee(storage) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return storage.remove(KEY_ICSTORAGE_KEY);
                case 2:
                    _ctx.next = 4;
                    return storage.remove(KEY_ICSTORAGE_DELEGATION);
                case 4:
                    _ctx.next = 6;
                    return storage.remove(KEY_ICSTORAGE_WALLET);
                case 6:
                    _ctx.next = 8;
                    return storage.remove(KEY_DELEGATION_PARAMS);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return __deleteStorage.apply(this, arguments);
}
export var ICStorage = /*#__PURE__*/ function() {
    "use strict";
    function ICStorage() {
        var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "astrox-", _localStorage = arguments.length > 1 ? arguments[1] : void 0;
        _classCallCheck(this, ICStorage);
        this.prefix = prefix;
        this._localStorage = _localStorage;
    }
    var _proto = ICStorage.prototype;
    _proto.get = function get(key) {
        return Promise.resolve(this._getICStorage().getItem(this.prefix + key));
    };
    _proto.set = function set(key, value) {
        this._getICStorage().setItem(this.prefix + key, value);
        return Promise.resolve();
    };
    _proto.remove = function remove(key) {
        this._getICStorage().removeItem(this.prefix + key);
        return Promise.resolve();
    };
    _proto._getICStorage = function _getICStorage() {
        if (this._localStorage) {
            return this._localStorage;
        }
        var ls = typeof window === "undefined" ? typeof global === "undefined" ? typeof self === "undefined" ? undefined : self.localStorage : global.localStorage : window.localStorage;
        if (!ls) {
            throw new Error("Could not find local storage.");
        }
        return ls;
    };
    return ICStorage;
}();
